import { When } from 'react-if';

import { Toolbar } from '@ui-core/toolbar';
import { isNativeDevice } from '@utils';

import useContainerService from './container.service';
import { ContainerProps } from './container.types';

export const Container: React.FC<ContainerProps> = ({
  children,
  toolbarOptions,
  className,
  safeArea = true,
  statusBar = true,
  ...rest
}: ContainerProps) => {
  const { cssClasses } = useContainerService({
    safeArea,
    className,
    toolbarOptions,
  });

  return (
    <div {...rest} className={cssClasses}>
      <When condition={statusBar && isNativeDevice}>
        <div className="container-wrapper-statusbar" />
      </When>
      {toolbarOptions && (
        <div className="toolbar-container">
          <Toolbar {...toolbarOptions} />
        </div>
      )}
      {children}
    </div>
  );
};
